<div
  class="wrapper--chip"
  [class.selected]="selected"
  [class.disabled]="disabled"
  (click)="select()"
>
  <span *ngIf="isNew" class="label-tag">{{ labelTag }}</span>
  <span class="label">{{ label }}</span>
  <ark-icon
    *ngIf="selected"
    class="icon"
    icon="system-close"
    size="micro"
    [color]="disabled ? 'light' : 'disabled'"
    (click)="remove()"
  ></ark-icon>
</div>
